import { IMAGES_URL } from '../constants/main';

export default function getResizedImageLogoUrl({
  quality = 70,
  width = 800,
  url,
}) {
  let imageFormat = url.split('.').pop();

  if (imageFormat === 'jpeg') {
    imageFormat = 'jpg';
  }

  if (imageFormat !== 'jpg' && imageFormat !== 'png') {
    imageFormat = 'jpg';
  }

  return `${IMAGES_URL}/${url}?w=${width}&h=${width}&rmode=max&format=${imageFormat}&quality=${quality}`;
}
